  <template>
  <v-content class="ma-0 pa-0 pb-5">
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title class="ml-3">Fracciones</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-tabs color="primary" slider-color="primary">
        <v-tab>
          <v-icon left>picture_in_picture</v-icon>Clasificador Fracciones
        </v-tab>
        <v-divider color="white" class="mx-0" vertical></v-divider>
        <v-tab>
          <v-icon left>picture_in_picture</v-icon>Clasificador Unidades
        </v-tab>
        <v-divider color="white" class="mx-0" vertical></v-divider>
        <v-tab>
          <v-icon left>list</v-icon>Tabla de Aplicabilidad
        </v-tab>
        <v-divider color="white" class="mx-0" vertical></v-divider>

        <v-tab-item class="px-5">
          <v-row class="mt-5" align="center" justify="end">
            <v-col cols="12" lg="4">
              <v-text-field solo label="Buscar" v-model="titlef"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="12" md="6" lg="3" text-sm-right v-for="(item, i) in searchFiltroF" :key="i">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-card
                    height="75px"
                    v-on="on"
                    class="pb-3"
                    style="margin-bottom:40px;  text-align: left!important"
                    @click="modalitem(item)"
                  >
                    <v-btn
                      dark
                      elevation="8"
                      style="margin-top:-20px; margin-left:15px "
                      :color="item.color"
                      height="60px"
                      width="60px"
                    >
                      <v-icon x-large>{{item.nombre}}</v-icon>
                    </v-btn>
                    <h4
                      style="margin-left:95px; margin-right:10px; margin-top:-25px"
                      class="block-ellipsis text--secondary"
                    >{{item.descripcionCorta}}</h4>
                  </v-card>
                </template>
                <span>{{item.fraccion}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-toolbar flat color="primary" dark>
            <v-toolbar-title class="ml-3">Específicas</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-row class="mt-10">
            <v-col sm="12" md="6" lg="3" text-sm-right v-for="(item, i) in searchFiltroFEspec" :key="i">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-card
                    height="75px"
                    v-on="on"
                    class="pb-3"
                    style="margin-bottom:40px;  text-align: left!important"
                    @click="modalitem(item)"
                  >
                    <v-btn
                      dark
                      elevation="8"
                      style="margin-top:-20px; margin-left:15px "
                      :color="item.color"
                      height="60px"
                      width="60px"
                    >
                      <v-icon x-large>{{item.nombre}}</v-icon>
                    </v-btn>
                    <h4
                      style="margin-left:95px; margin-right:10px; margin-top:-25px"
                      class="block-ellipsis text--secondary"
                    >{{item.descripcionCorta}}</h4>
                  </v-card>
                </template>
                <span>{{item.fraccion}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item class="px-5">
          <v-row class="mt-5" align="center" justify="end">
            <v-col cols="12" lg="4">
              <v-text-field solo label="Buscar" v-model="title"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="6" lg="3" text-sm-right v-for="(item, i) in searchFiltro" :key="i">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-card
                    height="75px"
                    v-on="on"
                    class="pb-3"
                    style="margin-bottom:40px;  text-align: left!important"
                    @click="modalitemUnidad(item)"
                  >
                    <v-btn
                      dark
                      elevation="8"
                      style="margin-top:-20px; margin-left:15px "
                      :color="item.color"
                      height="60px"
                      width="60px"
                    >
                      <v-icon x-large>{{item.icono}}</v-icon>
                    </v-btn>
                    <h4
                      style="margin-left:95px; margin-right:10px; margin-top:-25px"
                      class="block-ellipsis text--secondary"
                    >{{item.nombreUnidad}}</h4>
                  </v-card>
                </template>
                <span>{{item.nombreUnidad}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-card class="mt-5" elevation="0">
            <v-card-title class="pb-0">
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="search" label="Buscar" solo hide-details></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="desserts"
              sort-by="calories"
              class="elevation-0"
              :search="search"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Fracciones</v-toolbar-title>
                  <v-divider class="mx-3" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:item.aplica="{ item }">
                <v-btn
                  depressed
                  small
                  :color="getColor(item.aplica)"
                  dark
                  @click="modalaplica(item)"
                >{{gettxt(item.aplica)}}</v-btn>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon md class="mr-2" @click="modalitem(item)">find_in_page</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary">Datos no encontrados</v-btn>
              </template>
            </v-data-table>
          </v-card>
          <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        </v-tab-item>
      </v-tabs>
 <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <v-dialog
        v-model="dialog1"
        max-width="500px"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>No Aplíca {{ vunidad }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>{{textmodal }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog1 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
         <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
  <v-row
      justify="center"
    >
      <v-dialog
        v-model="dialogFraccionUnidad"
          max-width="1100"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            
            <v-btn icon dark @click="dialogFraccionUnidad = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ UnidadSEleccionada }}</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card>
            <v-data-table
              :headers="fnheaders"
              :items="dessertsPunidad"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top></template>
              <template v-slot:item.action="{ item }">
                <v-icon md class="mr-2" @click="modalitem(item)">find_in_page</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary">Datos no encontrados</v-btn>
              </template>
            </v-data-table>
          </v-card>
          <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        </v-card>
        <v-dialog
          v-model="dialogArcivoUnidad"
          max-width="1100"
        
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogArcivoUnidad = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ SdescripcionCorta }}</v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-icon md class="mr-2"   color="teal darken-2" @click="desArchivo(item)">save_alt</v-icon>
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
      </v-dialog>
 
       <v-dialog
          v-model="dialog"
          max-width="1100"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ SdescripcionCorta }}</v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-icon md class="mr-2"  color="teal darken-2" @click="desArchivo(item)">save_alt</v-icon>
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
         </v-row>
    </v-card>
  </v-content>
</template>

<script>
import PubFracciones from "./PubFracciones.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import axunidad from "axios";
import { async } from "q";

import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../services/FraccionService";

//let apiUrl = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let apiUrl = 'https://localhost:44340/'
let apiUrl = 'https://enjambrec.ugto.mx/RG/Transparencia/'

export default {
  components: { PubFracciones },

  props: [],

  data: () => ({
    
    backgroundColor: "primary",
    UnidadSEleccionada: "",
    SdescripcionCorta: "",
    dialogArcivoUnidad: false,
    Unidadid: 1,
    search: "",
    textmodal: "",
    step: 1,
    dialog: false,
    dialog1: false,
    dialogFraccionUnidad: false,
    list: null,
    title: "",
    titlef: "",
    window: 1,
    name: "",
    email: "",
    icon: "",
    fitems: [],
    select: null,
    details: {
      colors: [] // icons: []
    },
    formClasi: {
      icon: ""
    },

    checkbox: false,
    headers: [
      { text: " # ", value: "numFraccion" },
      { text: "Fraccion", value: "fraccion" },
      { text: "tipo fraccion", value: "tipoFraccion" },
      { text: "Aplicabilidad", value: "aplica" },
      { text: "Archivos", value: "action", sortable: false }
    ],

    aheaders: [
      { text: "Archivo ", value: "nombreArchivo" },
      // { text: "Fraccion", value: "descripcionCorta" },
      { text: "Año", value: "anio" },
      { text: "Periodo", value: "periodo" },
      { text: "Actualizacion", value: "fechaCreacion" },
      { text: "Descargar", value: "action", sortable: false }
    ],
    fnheaders: [
      { text: " # Fraccion", value: "numFraccion" },
      { text: "Fraccion", value: "fraccion" },
      { text: "tipo fraccion", value: "tipoFraccion" },
      { text: "Archivos", value: "action", sortable: false }
    ],
    edesserts: [],
    desserts: [],
    btndesserts: [],
    adesserts: [],
    editedIndex: -1,
    editedItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0
    },
    defaultItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0,
      idFraccion: 0
    },
    respddl: [],
    items: [],
    aitems: [],
    arid: 0,
    vunidad: "",
    dessertsPunidad: []
  }),

  computed: {
    styleHeader() {
      return {
        backgroundColor: this.formClasi.color,
        color: this.formClasi.forecolor
      };
    },

    ...mapGetters({
      oidcUser: "oidcStore/oidcUser",
      oidcAccessToken: "oidcStore/oidcAccessToken"
    }),

    slotData() {
      return {
        details: this.details
      };
    },

    isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    },

    searchFiltro: function() {
      return this.fitems.filter(item => item.nombreUnidad.toLowerCase().includes(this.title.toLowerCase()));
    },
    
    searchFiltroF: function() {
      return this.btndesserts.filter(item =>
        item.fraccion.toLowerCase().includes(this.titlef.toLowerCase())
      );
    },
    searchFiltroFEspec: function() {
      return this.edesserts.filter(item =>
        item.fraccion.toLowerCase().includes(this.titlef.toLowerCase())
      );
    }
  },

  watch: {},

  created() {
    let self = this;
    self.getCatUnidad();
  },

  methods: {
    ...mapActions({
      signOutOidc: "oidc/signOutOidc"
    }),

    getColor(aplica) {

      if (aplica > 1) return "red";
      else return "green";
    },

    gettxt(aplica) {
      //  console.log("aplica txt", aplica);
      if (aplica > 1) return "No aplíca";
      else return "Aplíca";
    },

    getCatUnidad() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getBtnUnidad().then(r => {
        this.fitems = r.data;
        console.log("cat unidad", this.fitems);
      });
      self.tblFraccion();
    },
    tblFraccion() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getCatFraccion().then(r => {
        this.desserts = r.data;
        console.log("desserts", this.desserts);
      });
      self.Fraccionbtn();
    },
    Fraccionbtn() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getCatFraccionC().then(r => {
        this.btndesserts = r.data;
        console.log("btndeserts", this.desserts);

      });
      self.Fraccione();
    },
    Fraccione() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getCatFraccionE().then(r => {
        this.edesserts = r.data;
        console.log("especifica", this.desserts);
        self.VisitaGeneral();
      });
    },
    VisitaGeneral(){
      let browserName;

    var ua= navigator.userAgent;
    var tem; 
    var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        browserName= 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) 
        {
        browserName= tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    {
        browserName= M.join(' ');
    }
  

      let self = this; 
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.visitaGeneral(browserName).then(r => {
              console.log("respuesta", r.data.data);      
      });
    },
    modalaplica(item) {

      if (item.aplica == 2) {
          console.log("mosalAplica", item);
      this.textmodal = item.descNoaplica;
      console.log("desdemodal 2", this.textmodal);
      this.dialog1 = true;
        
      }
    
    },

    modalitem(item) {
      let self = this;
        this.SdescripcionCorta=item.descripcionCorta;
      const index = this.desserts.indexOf(item);
      console.log("modal", item);
      this.unidadname=item.descripcionCorta;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);

      fraccionService
        .tblArchivosPubli(item.idFraccion)
        .then(r => {
          this.adesserts = r.data.map(e => {
            e.fechaCreacion = e.fechaCreacion.substr(0,10).split(" ")[0].split("-").reverse().join("-");
            //  console.log("pos si", e.fechaCreacion)
            return e
          });
          console.log("modalitemsadeserts", this.adesserts);
          self.fnVisitaFraccion(item.idFraccion);
        });

      this.dialog = true;
    },

    fnVisitaFraccion(id_fraccion)
    {
      let self = this;
      let browserName;

      var ua= navigator.userAgent;
      var tem; 
      var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        browserName= 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) 
        {
        browserName= tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
      {
        browserName= M.join(' ');
      }

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
        .visitaFraccion(id_fraccion,browserName)
        .then(r => {
     
          console.log("modalitemsadeserts", r.data.data);

        });
    },
    ///Pruebas de unidada y archivos
    modalitemUnidadArchivo(item) {
      let self = this;
      this.SdescripcionCorta=item.descripcionCorta;
      const index = this.desserts.indexOf(item);
      console.log("modalunidad", item);

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
        .tblArchivosPunidad(item.idUnidad)
        .then(r => {
          this.adesserts = r.data;
          console.log("modalitemsadeserts", this.adesserts);
        });
 
       this.dialogArcivoUnidad = true;
    },

    modalitemUnidad(item) {
      let self = this;
      this.UnidadSEleccionada=item.nombreUnidad;
      this.Unidadid=item.idUnidad;
      const index = this.desserts.indexOf(item);
      console.log("modalunidad", item.idUnidad);

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
        .getCatFraccionf(item.idUnidad)
        .then(r => {
          this.dessertsPunidad = r.data;
         
          console.log("regreso", this.dessertsPunidad);
        });

      this.dialogFraccionUnidad = true;
    },

    desArchivo(item) {
      let self = this;
      const index = this.desserts.indexOf(item);
      console.log("Archico", item);
       var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService

        .archivodow(item.idArchvio)
        .then(r => {
          this.adesserts = r.data;
       
          console.log( "adeserts",this.adesserts);
        });
      console.log(this.editedItem);
      this.dialog = true;
    },

    submit() {
      this.$v.$touch();
    },
  }
};
</script>

<style lang="scss" scoped>
.v-tab {
  background-color: gainsboro;
}

.v-tab--active {
  background-color: white;
}

.block-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  margin: 0 auto;
  line-height: 1.4;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-btn--floating.v-btn--left {
  margin-left: 0px !important;

  .v-icon {
    height: auto;
  }
}

.ds-calendar-event-popover-card {
  .v-toolbar__extension {
    padding: 0 16px !important;
    height: 60px !important;
    align-items: start;

    .v-toolbar__title {
      width: 100%;
      margin-left: 56px;
      margin-right: 0px;

      .v-input__slot {
        background-color: rgba(255, 255, 255, 0.2) !important;

        input {
          caret-color: rgba(0, 0, 0, 0.87) !important;
        }
      }
    }
  }
}

.v-text-field--full-width {
  width: 100%;
}

.v-card__text {
  padding: 16px 0;

  .v-list {
    padding-bottom: 0px;

    > div:first-child {
      margin-bottom: 1em;
    }

    .v-list__tile {
      height: auto !important;
    }
  }
}

.ds-create-popover-save {
  background-color: transparent !important;
}

.ds-color-option {
  width: 100%;
  color: white;
  padding: 4px;
}

.v-input {
  margin-bottom: 8px !important;
}
</style>


